'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint complexity: ["error", 20]*/

var ACTIVE_VALUES = ['Active', 'Aktiv', '有効にする', 'Активно', 'Activa', 'ενεργεία', 'Attiva'];

var DefaultStrategy = function () {
  function DefaultStrategy() {
    (0, _classCallCheck3.default)(this, DefaultStrategy);
  }

  (0, _createClass3.default)(DefaultStrategy, [{
    key: 'execute',
    value: function execute(paymentsMethodsObj, disableApplePay) {
      if (!paymentsMethodsObj) {
        return null;
      }

      var noCardMethods = !paymentsMethodsObj.cardMethods || paymentsMethodsObj.cardMethods.length < 1;
      var noRegisteredMethods = !paymentsMethodsObj.registeredMethods || paymentsMethodsObj.registeredMethods.length < 1;

      if (noCardMethods && noRegisteredMethods) {
        return null;
      }

      var allCardMethods = paymentsMethodsObj.cardMethods.map(function (cardMethod, cardIndex) {
        return (0, _extends3.default)({}, cardMethod.info, {
          cardIndex: cardIndex
        });
      });

      var activeCardMethods = allCardMethods.filter(function (cardMethod) {
        return ACTIVE_VALUES.includes(cardMethod.cardStatus);
      });

      var lastActiveCardIndex = paymentsMethodsObj.lastActiveCardIndex;

      var isLastActiveCardIndex = activeCardMethods.some(function (cardMethod) {
        return cardMethod.cardIndex === lastActiveCardIndex;
      });

      if (!isLastActiveCardIndex) {
        lastActiveCardIndex = activeCardMethods.length ? activeCardMethods[0].cardIndex : 0;
      }

      var isApplePayAvailable = paymentsMethodsObj.lastActiveMethod === 'APAY' && !disableApplePay;
      var registeredMethods = paymentsMethodsObj.registeredMethods || [];

      return activeCardMethods.length || isApplePayAvailable ? {
        activeCardMethods: activeCardMethods,
        lastActiveCardIndex: lastActiveCardIndex,
        registeredMethods: registeredMethods
      } : null;
    }
  }]);
  return DefaultStrategy;
}();

exports.default = DefaultStrategy;